import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    paddingTop: '1rem',
  },
  hint: {
    margin: '0 0 1rem 0',
    fontSize: '0.875rem',
    opacity: 0.7,
  },
})

export default useStyles
